$(document).ready(function () {
    $('.cases-slick').slick();
});